/* app/js/src/components/common/section-progressbar/section-progressbar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 100%;
}
div {
  font-size: 12px;
  color: #7d8fa1;
  background-color: #dde3e7;
  height: 29px;
  line-height: 29px;
  display: inline-block;
  padding-left: 29px;
  cursor: pointer;
}
div.selected {
  background-color: #f1f3f4;
  color: #232f3a;
}
/*# sourceMappingURL=section-progressbar.component.css.map */
